module.exports = __webpack_public_path__ + "static/media/ic_close.8d3a47b0.svg";